import { Container } from "react-bootstrap";
import CustomCardInfo from "../../components/CustomCardInfo";
import CustomCardAnnounce from "../../components/CustomCardAnnounce";
import CustomCardActionRequired from "../../components/CustomCardActionRequired";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { useEffect, useState } from "react";
import * as StorageManager from "../../utils/StorageManager";
import constants from "../../constants";
import * as axiosInstance from "../../services/axiosInstance";
import Helper from "../../utils/Helper";
import * as authSelectors from "../../selectors/auth";
import * as userSelectors from "../../selectors/user";
import clsx from "clsx";
import ActionRequiredRetailSection from "../ESettlement/components/ActionRequiredRetailSection";
function Dashboard({ generalData }) {
  const [page, setPage] = useState(1);
  const [token, setToken] = useState(null);
  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);
  const clientName = userSelectors.getUserName(userState);
  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }

  const announcementData = useQuery({
    queryKey: ["announcementList", { page }],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`clientarea/announcement?page=${page}`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch);
      }
    },
    retryDelay: 15000,
    placeholderData: keepPreviousData,
    enabled: !_.isEmpty(token),
  });

  const dashboardData = useQuery({
    queryKey: ["dashboardData"],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`clientarea/dashboard`);
      } catch (e) {
        Helper.handleHttpError(e, dispatch);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token),
  });

  const dashboardAccountSummary = _.get(
    dashboardData,
    ["data", "data", "account_summary"],
    null,
  );
  const dashboardOutStandingSummary = _.get(
    dashboardData,
    ["data", "data", "outstanding_summary"],
    null,
  );
  const dashboardMarginSummary = _.get(
    dashboardData,
    ["data", "data", "margin_summary"],
    null,
  );
  const dashboardMetaDataIsMargin = _.get(
    dashboardData,
    ["data", "data", "_metadata", "is_margin"],
    false,
  );
  const dashboardMetaDataIsRetail = _.get(
    dashboardData,
    ["data", "data", "_metadata", "is_retail"],
    false,
  );
  const annoucementItems = _.get(announcementData, ["data", "data"], null);
  const date = new Date();
  const dateNow = date.toISOString().split("T")[0];
  return (
    <Container fluid className="pb-5">
      {!_.isEmpty(dashboardAccountSummary)
        ? _.map(dashboardAccountSummary, (item, index) => {
            return (
              <CustomCardInfo
                key={index}
                index={index}
                item={item}
              ></CustomCardInfo>
            );
          })
        : false}
      {!_.isEmpty(annoucementItems) ? (
        <CustomCardAnnounce
          data={announcementData}
          page={page}
          setPage={setPage}
        ></CustomCardAnnounce>
      ) : (
        false
      )}
      {!_.isEmpty(dashboardMarginSummary) && dashboardMetaDataIsMargin ? (
        <CustomCardActionRequired
          key="required"
          data={dashboardMarginSummary}
        ></CustomCardActionRequired>
      ) : (
        false
      )}
      {!_.isEmpty(dashboardOutStandingSummary) && dashboardMetaDataIsRetail ? (
        <ActionRequiredRetailSection
          key="required"
          data={dashboardOutStandingSummary}
        ></ActionRequiredRetailSection>
      ) : (
        false
      )}
    </Container>
  );
}

export default Dashboard;
